var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dropdown-block"},_vm._l((_vm.list),function(item){return _c('dropdown-link',{key:item.id,attrs:{"item":item}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }